import { find, isString, map } from 'lodash-es';

import { ibanCountrySpecs } from '../constants/iban-validator.const';

const formatIban = (value: string): string =>
  value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

const composeIbanRegex = (structure: string): RegExp => {
  const groups = structure.match(/(.{3})/g);

  const regex = map(groups, (block): string => {
    let format = '';

    const pattern = block.slice(0, 1);
    const repeats = parseInt(block.slice(1), 10);

    switch (pattern) {
      case 'A':
        format = '0-9A-Za-z';
        break;
      case 'B':
        format = '0-9A-Z';
        break;
      case 'C':
        format = 'A-Za-z';
        break;
      case 'F':
        format = '0-9';
        break;
      case 'L':
        format = 'a-z';
        break;
      case 'U':
        format = 'A-Z';
        break;
      case 'W':
        format = '0-9a-z';
        break;
    }

    return `([${format}]{${repeats}})`;
  });

  return new RegExp(`^${regex.join('')}$`);
};

const toIso13616String = (iban: string): string => {
  const aCode = 'A'.charCodeAt(0);
  const zCode = 'Z'.charCodeAt(0);

  let res = iban.toUpperCase();

  res = `${res.substring(4)}${res.substring(0, 4)}`;

  return res
    .split('')
    .map((char) => {
      const code = char.charCodeAt(0);

      if (code >= aCode && code <= zCode) {
        return code - aCode + 10;
      }
      return char;
    })
    .join('');
};

/**
 * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
 *
 * @param iban
 * @returns {number}
 */
const computeMod97 = (iban: string): number => {
  let remainder = iban;
  let block;

  while (remainder.length > 2) {
    block = remainder.slice(0, 9);
    remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
  }

  return parseInt(remainder, 10) % 97;
};

export const isValidIban = (value: any): boolean => {
  if (!isString(value) || value.trim().length === 0) {
    return false;
  }

  const iban = formatIban(value);
  const countryCode = iban.slice(0, 2);
  const countrySpec = find(ibanCountrySpecs, {
    countryCode,
  });

  if (!countrySpec) {
    return false;
  }

  if (iban.length !== countrySpec.length) {
    return false;
  }

  const ibanRegExp = composeIbanRegex(countrySpec.structure);

  //   console.table({
  //     ...countrySpec,
  //     ibanRegExp: ibanRegExp.toString(),
  //     isoString: toIso13616String(iban),
  //   });

  if (!ibanRegExp.test(iban.slice(4))) {
    return false;
  }

  if (computeMod97(toIso13616String(iban)) !== 1) {
    return false;
  }

  return true;
};
